module.exports = __webpack_public_path__ + "img/myinfor.cfdf80ad.png";